import { CSSProperties } from "react";
import { GrBox, GrButton, GrIconButton, GrStack } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_DOCUMENT_SIGN_LANG } from "@maven-msg/lang/docs";

interface DrawingToolbarProps {
  isDownloadable?: boolean;
  toolbarStyle?: CSSProperties;
  drawDownloadButtonDisabled?: boolean;
  undoDisabled?: boolean;
  redoDisabled?: boolean;
  onClickUndo: () => void;
  onClickRedo: () => void;
  onClickClear?: () => void;
  onClickDrawDownload?: () => void;
}

export function DrawingToolbar({
  isDownloadable,
  toolbarStyle,
  drawDownloadButtonDisabled,
  undoDisabled,
  redoDisabled,
  onClickUndo,
  onClickRedo,
  onClickClear,
  onClickDrawDownload,
}: DrawingToolbarProps) {
  return (
    <GrStack alignItems="center" justifyContent="space-between" style={toolbarStyle}>
      {isDownloadable ? (
        <GrButton color="grey" variant="text" onClick={onClickDrawDownload} disabled={drawDownloadButtonDisabled}>
          {MvnMessage(DOCS_DOCUMENT_SIGN_LANG.DOCUMENT_SIGN_SIGNATURE_DOWNLOAD_LABEL)}
        </GrButton>
      ) : (
        <GrBox />
      )}

      <GrStack gap={2}>
        <GrIconButton disabled={undoDisabled} iconType="arrow-back-up" size={16} color="grey060" onClick={onClickUndo} />

        <GrIconButton disabled={redoDisabled} iconType="arrow-forward-up" size={16} color="grey060" onClick={onClickRedo} />
      </GrStack>
    </GrStack>
  );
}
